import ItemCardClub from "shared/components/items/ItemCardClub.js";
import LoadingSquare from "shared/components/loading/LoadingSquare.js";
import React, { useState, useEffect } from "react";
import { getClubs } from "shared/services/api-assistant.js";

interface ControllerClubs2Props {
  onSelect: func;
  selectedClubId: Object;
  userId: String;
  excludeArena?: boolean;
  clubs?: Array<Object> | null;
}

const ControllerClubs2: React.FC<ControllerClubs2Props> = ({ onSelect, selectedClubId, userId, excludeArena = false, clubs: providedClubs }) => {
  const [fetchedClubs, setFetchedClubs] = useState(null);
  const clubs = providedClubs ?? fetchedClubs;

  useEffect(() => {
    if (providedClubs !== undefined) return;

    getClubs({
      handleSuccess: (d) => {
        const availableClubs = excludeArena ? d.data.getClubs.filter((club) => club.type !== "ARENA") : d.data.getClubs;
        setFetchedClubs(availableClubs.sort((a, b) => a.division - b.division));
      },
      handleError: (e) => console.log(e),
      params: { owners: [userId], considerStaffMembers: true },
    });
  }, [providedClubs, excludeArena, userId]);

  return (
    <div className="d-flex flex-row flex-md-column w-100 overflow-auto align-items-start">
      {clubs ? (
        clubs.map((p) => (
          <ItemCardClub
            id={p.id}
            onClick={() => {
              onSelect(p);
            }}
            selected={selectedClubId === p.id}
            tag={p.type === "ARENA" ? "Arena" : userId ? (userId === p.owner?.id ? "Owner" : "Staff") : null}
          />
        ))
      ) : (
        <div className="ratio ratio-1x1 w-100" style={{ height: "60px" }}>
          <LoadingSquare />
        </div>
      )}
    </div>
  );
};

export default ControllerClubs2;
